import * as angular from "angular";

import "../../../components/validation-callout/validation-callout.less";
import template from "./validation-messages.html";

export default angular.module("vesl.extensions.json-schema.validation-messages", [])
	.component("jsonSchemaValidationMessages", {
		template,
		bindings: {
			messages: "<",
			heading: "@?"
		}
	})
	.name;
